import React from 'react';
import styles from './forbidden.module.scss';
import { useTranslation } from "react-i18next";
import { ReactComponent as ForbiddenIcon } from "@/assets/icons/forbidden.svg";


export const Forbidden: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.pageContainer}>
            <div className={styles.logoContainer}><ForbiddenIcon /></div>
            <h2 className={styles.text}>{t('forbidden')}</h2>
            <p className={styles.subText}>
                {t('forbidden_msg')}
            </p>
        </div>
    );
}

